import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 36178 36178"
    {...props}
  >
    <path
      d="M11151 1239h13877c5451 0 9911 4460 9911 9912v13877c0 5451-4460 9911-9911 9911H1239V11151c0-5452 4460-9912 9912-9912z"
      style={{
        fill: "none",
        stroke: "#2b2a29",
        strokeWidth: 2477.94,
      }}
      className="stroke1"
    />
  </svg>
)
export default SvgComponent
